import { AGGREGATION_TYPE } from 'components/View/constants';

export const WIDGET_MODAL_TYPE = {
  ADD: 'add',
  EDIT: 'edit',
};

export const DATA_RANGE_TYPE = {
  NOW: 'now',
  OVERTIME: 'overtime',
  GROUPED: 'grouped',
};

export const DATA_DISPLAY_TYPE = {
  GRAPH: 'graph',
  TABLE: 'table',
};

export const PRICE_DISPLAY_TYPE = {
  SINGLE: 1,
  SINGLE_AND_SECOND_PERSON: 2,
};

export const DEFAULT_WIDGET = {
  type: '',
  name: '',
  note: '',
  filters: {
    competitors: [],
    careTypes: [],
    roomTypes: [],
    roomTypesPriceDisplay: AGGREGATION_TYPE.AVG,
    careLevels: [],
    medicationLevels: [],
    reviewSources: [],
    reviewCategories: [],
    swotCategories: [],
    amenityCategories: [],
    contractTypes: [],
    careLevelsStatsType: AGGREGATION_TYPE.AVG,
    medicationLevelsStatsType: AGGREGATION_TYPE.AVG,
  },
};

export const DATA_GROUPING_TYPE = {
  ROOM_TYPE: 1,
  SQ_FT: 2,
  CARE_TYPE: 3,
  REVIEW_SOURCE: 4,
  REVIEW_CATEGORY: 5,
};

export const DATA_GROUPING_TYPE_LABELS = {
  [DATA_GROUPING_TYPE.ROOM_TYPE]: 'By room type',
  [DATA_GROUPING_TYPE.SQ_FT]: 'By room sq ft',
  [DATA_GROUPING_TYPE.CARE_TYPE]: 'By care type',
  [DATA_GROUPING_TYPE.REVIEW_SOURCE]: 'By review source',
  [DATA_GROUPING_TYPE.REVIEW_CATEGORY]: 'By review category',
};

export const WIDGET_GROUPING_SQ_FT_CATEGORIES_DEFAULT = [
  {
    range_start: 0,
    range_end: 500,
  },
  {
    range_start: 501,
    range_end: 750,
  },
  {
    range_start: 751,
    range_end: 1000,
  },
  {
    range_start: 1001,
    range_end: 1200,
  },
  {
    range_start: 1201,
    range_end: 2000,
  },
];
